import {capitalize} from "../../../utils";

export const staffingCenterTableConfig = (staffing, typeOfTime = []) => {
    if (!staffing) return {
        dropdown: false,
        dropdownLeftPadding: false,
        greyBackground: false,
        subline: true,
        columnConfig: [
            {
                label: '-',
                value: '',
                width: 'w-[7%]',
                sort: true,
                component: () => {
                    return (
                        <div className="flex flex-row items-center justify-center w-full">
                                -
                        </div>
                    );
                },
                sumDisplayed: false,
                sumBy: '',
                sumLabel: ''
            },
            {
                label: '-',
                value: '',
                width: 'w-[7%]',
                sort: true,
                component: () => {
                    return (
                        <div className="flex flex-row items-center justify-center w-full">
                                -
                        </div>
                    );
                },
                sumDisplayed: false,
                sumBy: '',
                sumLabel: ''
            },
            {
                label: '-',
                value: '',
                width: 'w-[7%]',
                sort: true,
                component: () => {
                    return (
                        <div className="flex flex-row items-center justify-center w-full">
                                -
                        </div>
                    );
                },
                sumDisplayed: false,
                sumBy: '',
                sumLabel: ''
            },
            {
                label: '-',
                value: '',
                width: 'w-[7%]',
                sort: true,
                component: () => {
                    return (
                        <div className="flex flex-row items-center justify-center w-full">
                                -
                        </div>
                    );
                },
                sumDisplayed: false,
                sumBy: '',
                sumLabel: ''
            },
            {
                label: '-',
                value: '',
                width: 'w-[7%]',
                sort: true,
                component: () => {
                    return (
                        <div className="flex flex-row items-center justify-center w-full">
                                -
                        </div>
                    );
                },
                sumDisplayed: false,
                sumBy: '',
                sumLabel: ''
            },
            {
                label: '-',
                value: '',
                width: 'w-[7%]',
                sort: true,
                component: () => {
                    return (
                        <div className="flex flex-row items-center justify-center w-full">
                                -
                        </div>
                    );
                },
                sumDisplayed: false,
                sumBy: '',
                sumLabel: ''
            }
        ]
    }
    else {
        const columns = [];

        for (const key in staffing) {
            columns.push({
                label: capitalize(new Date(key).toLocaleString('fr-FR', { month: 'short', year: 'numeric' })),
                value: `staffing.${key}.staffed`,
                width: 'w-1/6',
                sort: true,
                component: (item) => {
                    const staffed = item.staffing[key]?.staffed;
                    const available = item.staffing[key]?.available;
                    const noValue = (staffed === 0 || staffed === null || staffed === undefined || staffed === "") ? true : false;

                    let displayValue = '-';
                    let sumAvailableTypes = 0;// Somme des types sélectionnés dans available

                    if (available && typeOfTime && typeOfTime.length > 0 && typeOfTime.length < 3) {
                        sumAvailableTypes = typeOfTime.reduce((acc, f) => {
                            if (available[f] !== undefined) {
                                return acc + Number(available[f]);
                            }
                            return acc;
                        }, 0);
                    } else {
                        sumAvailableTypes = available.total; // Si pas de types sélectionnés, on prend la valeur total
                    }

                    if (!noValue && available && available.total > 0) {
                        if (!typeOfTime || typeOfTime.length === 0 || typeOfTime.length === 3) {
                            displayValue = Number(staffed).toFixed(1);
                        } else {
                            let sum = 0;
                            typeOfTime.forEach(f => {
                                if (available[f] !== undefined) {
                                    sum += staffed * ((available[f] * 100) / available.total);
                                }
                            });
                            displayValue = sum.toFixed(1);
                        }
                    }

                    let colorClass = "";
                    if (!noValue && available && available.total > 0) {
                        if (sumAvailableTypes < displayValue) colorClass = "text-red-600";
                        else if (sumAvailableTypes > displayValue) colorClass = "text-[#2CA951]";
                        else if (sumAvailableTypes === displayValue) colorClass = "text-[#F0A841]";
                    }

                    return (
                        <div className={`flex flex-row items-center justify-center w-full font-extrabold`}>
                            <p className={noValue ? "" : colorClass}>{displayValue}</p>
                        </div>
                    );
                },
                sumDisplayed: true,
                sumBy: 'value',
                sumLabel: ''
            });
        }

        return {
            dropdown: false,
            dropdownLeftPadding: false,
            greyBackground: false,
            subline: true,
            columnConfig: columns
        };
    }
}
